import React from "react";

export default function About(props) {
  return (
    <div >
    <div className="container"  style={{ color: props.mode === "dark" ? "white" : "#002F6C" }}>
      <h2>About Textconverter</h2>
    <div className="accordion" id="accordionPanelsStayOpenExample">
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingOne">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#panelsStayOpen-collapseOne"
            aria-expanded="true"
            aria-controls="panelsStayOpen-collapseOne"
            style={{backgroundColor: props.mode === "dark" ? "#343a40" : "#0dcaf0",
            color: props.mode === "dark" ? "white" : "#042743",
          }}

          >
            Text converter
          </button>
        </h2>
        <div
          id="panelsStayOpen-collapseOne"
          className="accordion-collapse collapse show"
          aria-labelledby="panelsStayOpen-headingOne"
        >
          <div className="accordion-body"style={{
              backgroundColor: props.mode === "dark" ? "#cfe2ff" : "white",
              color: props.mode === "dark" ? "black" : "#042743",
            }}>
            <strong style={{ color: props.mode === "dark" ? "white" : "#002F6C" }}>This is the first item's accordion body.</strong> It is
            shown by default, until the collapse plugin adds the appropriate
            classNamees that we use to style each element. These classNamees
            control the overall appearance, as well as the showing and hiding
            via CSS transitions. You can modify any of this with custom CSS or
            overriding our default variables. It's also worth noting that just
            about any HTML can go within the <code>.accordion-body</code>,
            though the transition does limit overflow.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#panelsStayOpen-collapseTwo"
            aria-expanded="false"
            aria-controls="panelsStayOpen-collapseTwo"
            style={{backgroundColor: props.mode === "dark" ? "#343a40" : "#0dcaf0",
            color: props.mode === "dark" ? "white" : "#042743",
          }}
          >
            Contact Us
          </button>
        </h2>
        <div
          id="panelsStayOpen-collapseTwo"
          className="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-headingTwo"
        >
          <div className="accordion-body"style={{
              backgroundColor: props.mode === "dark" ? "#cfe2ff" : "white",
              color: props.mode === "dark" ? "black" : "#042743",
            }}>
            <strong style={{ color: props.mode === "dark" ? "white" : "#002F6C" }}>This is the second item's accordion body.</strong> It is
            hidden by default, until the collapse plugin adds the appropriate
            classNamees that we use to style each element. These classNamees
            control the overall appearance, as well as the showing and hiding
            via CSS transitions. You can modify any of this with custom CSS or
            overriding our default variables. It's also worth noting that just
            about any HTML can go within the <code>.accordion-body</code>,
            though the transition does limit overflow.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingThree">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#panelsStayOpen-collapseThree"
            aria-expanded="false"
            aria-controls="panelsStayOpen-collapseThree"
            style={{backgroundColor: props.mode === "dark" ? "#343a40" : "#0dcaf0",
            color: props.mode === "dark" ? "white" : "#042743",
          }}
          >
            Learn to use
          </button>
        </h2>
        <div
          id="panelsStayOpen-collapseThree"
          className="accordion-collapse collapse"
          aria-labelledby="panelsStayOpen-headingThree"
          
          
        >
          <div className="accordion-body"style={{
              backgroundColor: props.mode === "dark" ? "#cfe2ff" : "white",
              color: props.mode === "dark" ? "black" : "#042743",
            }}>
            <strong style={{ color: props.mode === "dark" ? "white" : "#002F6C" }}>This is the third item's accordion body.</strong> It is
            hidden by default, until the collapse plugin adds the appropriate
            classNamees that we use to style each element. These classNamees
            control the overall appearance, as well as the showing and hiding
            via CSS transitions. You can modify any of this with custom CSS or
            overriding our default variables. It's also worth noting that just
            about any HTML can go within the <code>.accordion-body</code>,
            though the transition does limit overflow.
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
}
